import { openDialog } from '../../../react/features/base/dialog/actions';
import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import { isTestModeEnabled } from '../../../react/features/base/testing/functions';
import { getVisitorsCount, iAmVisitor } from '../../../react/features/visitors/functions';
import { isWebinarEnabledInRoom } from '../../../x-bees/components/webinar/functions';

import { PopupAlone } from './components';
import { POPUP_ALONE_TIMEOUT } from './constants';
import { getIsConferenceJoined } from './functions';

let timeout;

StateListenerRegistry.register(
    /* selector */ state => state['features/base/participants'].remote.size,
    /* listener */ (size, { getState, dispatch }, prevSize) => {
        const state = getState();
        const { iAmRecorder } = state['features/base/config'];

        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }

        if (iAmRecorder
            || getVisitorsCount(state) > 0
            || isWebinarEnabledInRoom(state)
            || iAmVisitor(state)
            || isTestModeEnabled(state)) {
            return;
        }


        if (size === 0 && typeof prevSize === 'number') {
            timeout = setTimeout(() => {
                if (getIsConferenceJoined(getState())) {
                    dispatch(openDialog(PopupAlone));
                }
            }, POPUP_ALONE_TIMEOUT);
        }
    });
